import React, { Component, PropTypes } from "react";
import  { FormGroup, ControlLabel, FormControl, HelpBlock } from "react-bootstrap";


class FormField extends Component {
  render() {
    const {
      controlId,
      feedback,
      validationState,
      label,
      help,
      children,
      ...props
    } = this.props;

    return (
      <FormGroup
        controlId={controlId}
        validationState={validationState}>
        {label && <ControlLabel>{label}</ControlLabel>}
        <FormControl { ...props}>{children}</FormControl>
        {feedback && <FormControl.Feedback />}
        {help && <HelpBlock>{help}</HelpBlock>}
      </FormGroup>
    );
  }
}


FormField.propTypes = {
  controlId: PropTypes.string.isRequired,
  feedback: PropTypes.bool,
  validationState: PropTypes.string,
  label: PropTypes.string,
  help: PropTypes.string
};

FormField.defaultProps = {
  feedback: true,
};

export default FormField;


// WEBPACK FOOTER //
// ./src/components/Froms/FormField.js